import { Card, Text, Button, Group } from '@mantine/core';

export default function GrandslamCard({
  type,
  handleButtonWinterslam,
}: {
  type: 'defense' | 'conrad' | 'fullprotection' | 'agna' | 'tps' | 'vasanello' | 'gualtieri';
  handleButtonWinterslam: Function;
}) {
  let imageUrl = '';
  let linkPdfMatch = '';
  const linkSubscription = '';
  let linkPractiscore = null;
  let title = '';
  switch (type) {
    case 'defense':
      imageUrl = '/grandslam/defense.png';
      // linkSubscription = 'https://www.practiscore.com/1-prova-brownells-grand-slam/register';
      linkPractiscore = 'https://www.practiscore.com/results/new/243292';
      linkPdfMatch = '/grandslam/locandina_defense.pdf';
      title = 'Defense360°';
      break;
    case 'fullprotection':
      imageUrl = '/grandslam/fullprotection.png';
      // linkSubscription = 'https://www.practiscore.com/2-prova-brownells-grand-slam/register';
      linkPractiscore = 'https://practiscore.com/results/new/245279';
      title = 'Full Protection';
      break;
    case 'agna':
      imageUrl = '/grandslam/phalanx.png';
      // linkSubscription = 'https://practiscore.com/brownells-winter-slam-30-prova/register';
      linkPractiscore = 'https://practiscore.com/results/new/252501';
      title = 'Phalanx - Agna';
      break;
    case 'conrad':
      imageUrl = '/grandslam/conrad.png';
      // linkSubscription = 'https://www.practiscore.com/30-prova-brownells-grand-slam/register';
      linkPractiscore = 'https://practiscore.com/results/new/156c6976-8df1-460e-b8e3-edee96ab9713?fbclid=IwZXh0bgNhZW0CMTEAAR2wFY391N6jLff8TVL_dvLcERrqMkQZ5HGYew6JAZCSCqOoq30oZFtP6AU_aem_AbiPRXmxVSY5NjAXAIX1-vwoRL_lhKyrWds5NKwMoontxwI50ylHMLGb4nX31NHiCKdYGL6QvV8CEZDPPbg5RST5';
      title = 'Conrad';
      break;
    case 'tps':
      imageUrl = '/grandslam/tps.png';
      // linkSubscription = 'https://practiscore.com/40-winter-slam/register';
      linkPractiscore = 'https://practiscore.com/results/new/802644c0-dd23-475d-8a83-1a441d289b59';
      title = 'TPS Dynamic';
      break;
    case 'vasanello':
      imageUrl = '/grandslam/vasanello.png';
      // linkSubscription = 'https://practiscore.com/40-winter-slam/register';
      // linkPractiscore = 'https://practiscore.com/results/html/59df9776-78dd-4f0c-9cc5-78657c2025be';
      title = 'Vasanello Shooting';
      break;
    case 'gualtieri':
      imageUrl = '/grandslam/phalanx.png';
      // linkSubscription = 'https://practiscore.com/40-winter-slam/register';
      // linkPractiscore = 'https://practiscore.com/results/html/59df9776-78dd-4f0c-9cc5-78657c2025be';
      title = 'Phalanx - Gualtieri';
      break;

    default:
      break;
  }
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section
        style={{
          height: 160,
          display: 'flex',
          overflow: 'hidden',
          alignItems: ' center',
          justifyContent: 'center',
        }}
      >
        <img
          src={imageUrl}
          height="auto"
          width="100%"
          style={{ maxHeight: 140, maxWidth: 140 }}
          alt="Logo"
        />
      </Card.Section>

      <Group position="center" mt="md" mb="xs">
        <Text weight={500}>{title}</Text>
      </Group>

      {!linkPractiscore && (
        <Button
          component="a"
          href={linkSubscription}
          target="_blank"
          variant="light"
          color="blue"
          fullWidth
          mt="md"
          radius="md"
          disabled={!linkSubscription}
        >
          Iscriviti
        </Button>
      )}
      {!linkPractiscore && (
        <Button
          component="a"
          href={linkPdfMatch}
          target="_blank"
          variant="light"
          color="grape"
          fullWidth
          mt="md"
          radius="md"
          disabled={!linkPdfMatch}
        >
          Locandina
        </Button>
      )}
      <Button
        component="a"
        href={linkPractiscore || '#'}
        target="_blank"
        variant="light"
        color="green"
        fullWidth
        mt="md"
        radius="md"
        disabled={!linkPractiscore}
      >
        Classifica Practiscore
      </Button>
      <Button
        onClick={() => handleButtonWinterslam(type)}
        variant="light"
        color="red"
        fullWidth
        mt="md"
        radius="md"
        disabled={!linkPractiscore}
      >
        Classifica Grandslam
      </Button>
    </Card>
  );
}
